// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file walletpasses/v1/walletpasses.proto (package walletpasses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Destination, DestinationJson } from "../../codes/v3/codes_pb";
import { file_codes_v3_codes } from "../../codes/v3/codes_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { FieldMask, FieldMaskJson, StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file walletpasses/v1/walletpasses.proto.
 */
export const file_walletpasses_v1_walletpasses: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_codes_v3_codes, file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_timestamp, file_google_protobuf_field_mask, file_google_protobuf_struct],
	);

/**
 * @generated from message walletpasses.v1.WalletPassBatch
 */
export type WalletPassBatch = Message<"walletpasses.v1.WalletPassBatch"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string provider_id = 2;
	 */
	providerId: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string state = 8;
	 */
	state: string;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 10;
	 */
	tags: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message walletpasses.v1.WalletPassBatch
 */
export type WalletPassBatchJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string provider_id = 2;
	 */
	providerId?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string state = 8;
	 */
	state?: string;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 10;
	 */
	tags?: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message walletpasses.v1.WalletPassBatch.
 * Use `create(WalletPassBatchSchema)` to create a new message.
 */
export const WalletPassBatchSchema: GenMessage<WalletPassBatch, { jsonType: WalletPassBatchJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 0);

/**
 * @generated from message walletpasses.v1.CreateWalletPassBatchRequest
 */
export type CreateWalletPassBatchRequest = Message<"walletpasses.v1.CreateWalletPassBatchRequest"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatch | undefined;
};

/**
 * @generated from message walletpasses.v1.CreateWalletPassBatchRequest
 */
export type CreateWalletPassBatchRequestJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatchJson;
};

/**
 * Describes the message walletpasses.v1.CreateWalletPassBatchRequest.
 * Use `create(CreateWalletPassBatchRequestSchema)` to create a new message.
 */
export const CreateWalletPassBatchRequestSchema: GenMessage<CreateWalletPassBatchRequest, { jsonType: CreateWalletPassBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 1);

/**
 * @generated from message walletpasses.v1.CreateWalletPassBatchResponse
 */
export type CreateWalletPassBatchResponse = Message<"walletpasses.v1.CreateWalletPassBatchResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatch | undefined;
};

/**
 * @generated from message walletpasses.v1.CreateWalletPassBatchResponse
 */
export type CreateWalletPassBatchResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatchJson;
};

/**
 * Describes the message walletpasses.v1.CreateWalletPassBatchResponse.
 * Use `create(CreateWalletPassBatchResponseSchema)` to create a new message.
 */
export const CreateWalletPassBatchResponseSchema: GenMessage<CreateWalletPassBatchResponse, { jsonType: CreateWalletPassBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 2);

/**
 * @generated from message walletpasses.v1.GetWalletPassBatchRequest
 */
export type GetWalletPassBatchRequest = Message<"walletpasses.v1.GetWalletPassBatchRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message walletpasses.v1.GetWalletPassBatchRequest
 */
export type GetWalletPassBatchRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message walletpasses.v1.GetWalletPassBatchRequest.
 * Use `create(GetWalletPassBatchRequestSchema)` to create a new message.
 */
export const GetWalletPassBatchRequestSchema: GenMessage<GetWalletPassBatchRequest, { jsonType: GetWalletPassBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 3);

/**
 * @generated from message walletpasses.v1.GetWalletPassBatchResponse
 */
export type GetWalletPassBatchResponse = Message<"walletpasses.v1.GetWalletPassBatchResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatch | undefined;
};

/**
 * @generated from message walletpasses.v1.GetWalletPassBatchResponse
 */
export type GetWalletPassBatchResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatchJson;
};

/**
 * Describes the message walletpasses.v1.GetWalletPassBatchResponse.
 * Use `create(GetWalletPassBatchResponseSchema)` to create a new message.
 */
export const GetWalletPassBatchResponseSchema: GenMessage<GetWalletPassBatchResponse, { jsonType: GetWalletPassBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 4);

/**
 * @generated from message walletpasses.v1.ListWalletPassBatchesRequest
 */
export type ListWalletPassBatchesRequest = Message<"walletpasses.v1.ListWalletPassBatchesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string folder_id = 3;
	 */
	folderId: string;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message walletpasses.v1.ListWalletPassBatchesRequest
 */
export type ListWalletPassBatchesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string folder_id = 3;
	 */
	folderId?: string;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message walletpasses.v1.ListWalletPassBatchesRequest.
 * Use `create(ListWalletPassBatchesRequestSchema)` to create a new message.
 */
export const ListWalletPassBatchesRequestSchema: GenMessage<ListWalletPassBatchesRequest, { jsonType: ListWalletPassBatchesRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 5);

/**
 * @generated from message walletpasses.v1.ListWalletPassBatchesResponse
 */
export type ListWalletPassBatchesResponse = Message<"walletpasses.v1.ListWalletPassBatchesResponse"> & {
	/**
	 * @generated from field: repeated walletpasses.v1.WalletPassBatch wallet_pass_batches = 1;
	 */
	walletPassBatches: WalletPassBatch[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message walletpasses.v1.ListWalletPassBatchesResponse
 */
export type ListWalletPassBatchesResponseJson = {
	/**
	 * @generated from field: repeated walletpasses.v1.WalletPassBatch wallet_pass_batches = 1;
	 */
	walletPassBatches?: WalletPassBatchJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message walletpasses.v1.ListWalletPassBatchesResponse.
 * Use `create(ListWalletPassBatchesResponseSchema)` to create a new message.
 */
export const ListWalletPassBatchesResponseSchema: GenMessage<ListWalletPassBatchesResponse, { jsonType: ListWalletPassBatchesResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 6);

/**
 * @generated from message walletpasses.v1.UpdateWalletPassBatchRequest
 */
export type UpdateWalletPassBatchRequest = Message<"walletpasses.v1.UpdateWalletPassBatchRequest"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatch | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message walletpasses.v1.UpdateWalletPassBatchRequest
 */
export type UpdateWalletPassBatchRequestJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatchJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message walletpasses.v1.UpdateWalletPassBatchRequest.
 * Use `create(UpdateWalletPassBatchRequestSchema)` to create a new message.
 */
export const UpdateWalletPassBatchRequestSchema: GenMessage<UpdateWalletPassBatchRequest, { jsonType: UpdateWalletPassBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 7);

/**
 * @generated from message walletpasses.v1.UpdateWalletPassBatchResponse
 */
export type UpdateWalletPassBatchResponse = Message<"walletpasses.v1.UpdateWalletPassBatchResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatch | undefined;
};

/**
 * @generated from message walletpasses.v1.UpdateWalletPassBatchResponse
 */
export type UpdateWalletPassBatchResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 1;
	 */
	walletPassBatch?: WalletPassBatchJson;
};

/**
 * Describes the message walletpasses.v1.UpdateWalletPassBatchResponse.
 * Use `create(UpdateWalletPassBatchResponseSchema)` to create a new message.
 */
export const UpdateWalletPassBatchResponseSchema: GenMessage<UpdateWalletPassBatchResponse, { jsonType: UpdateWalletPassBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 8);

/**
 * @generated from message walletpasses.v1.DeleteWalletPassBatchRequest
 */
export type DeleteWalletPassBatchRequest = Message<"walletpasses.v1.DeleteWalletPassBatchRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message walletpasses.v1.DeleteWalletPassBatchRequest
 */
export type DeleteWalletPassBatchRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message walletpasses.v1.DeleteWalletPassBatchRequest.
 * Use `create(DeleteWalletPassBatchRequestSchema)` to create a new message.
 */
export const DeleteWalletPassBatchRequestSchema: GenMessage<DeleteWalletPassBatchRequest, { jsonType: DeleteWalletPassBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 9);

/**
 * @generated from message walletpasses.v1.DeleteWalletPassBatchResponse
 */
export type DeleteWalletPassBatchResponse = Message<"walletpasses.v1.DeleteWalletPassBatchResponse"> & {};

/**
 * @generated from message walletpasses.v1.DeleteWalletPassBatchResponse
 */
export type DeleteWalletPassBatchResponseJson = {};

/**
 * Describes the message walletpasses.v1.DeleteWalletPassBatchResponse.
 * Use `create(DeleteWalletPassBatchResponseSchema)` to create a new message.
 */
export const DeleteWalletPassBatchResponseSchema: GenMessage<DeleteWalletPassBatchResponse, { jsonType: DeleteWalletPassBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 10);

/**
 * @generated from message walletpasses.v1.WalletPassTemplate
 */
export type WalletPassTemplate = Message<"walletpasses.v1.WalletPassTemplate"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string provider_id = 2;
	 */
	providerId: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string state = 8;
	 */
	state: string;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 10;
	 */
	tags: string[];

	/**
	 * @generated from field: string version = 11;
	 */
	version: string;

	/**
	 * @generated from field: string visibility = 16;
	 */
	visibility: string;

	/**
	 * @generated from field: string destination = 12;
	 */
	destination: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 17;
	 */
	config?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 14;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 15;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message walletpasses.v1.WalletPassTemplate
 */
export type WalletPassTemplateJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string provider_id = 2;
	 */
	providerId?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string state = 8;
	 */
	state?: string;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 10;
	 */
	tags?: string[];

	/**
	 * @generated from field: string version = 11;
	 */
	version?: string;

	/**
	 * @generated from field: string visibility = 16;
	 */
	visibility?: string;

	/**
	 * @generated from field: string destination = 12;
	 */
	destination?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 17;
	 */
	config?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 14;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 15;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message walletpasses.v1.WalletPassTemplate.
 * Use `create(WalletPassTemplateSchema)` to create a new message.
 */
export const WalletPassTemplateSchema: GenMessage<WalletPassTemplate, { jsonType: WalletPassTemplateJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 11);

/**
 * @generated from message walletpasses.v1.CreateWalletPassTemplateRequest
 */
export type CreateWalletPassTemplateRequest = Message<"walletpasses.v1.CreateWalletPassTemplateRequest"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplate | undefined;
};

/**
 * @generated from message walletpasses.v1.CreateWalletPassTemplateRequest
 */
export type CreateWalletPassTemplateRequestJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplateJson;
};

/**
 * Describes the message walletpasses.v1.CreateWalletPassTemplateRequest.
 * Use `create(CreateWalletPassTemplateRequestSchema)` to create a new message.
 */
export const CreateWalletPassTemplateRequestSchema: GenMessage<CreateWalletPassTemplateRequest, { jsonType: CreateWalletPassTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 12);

/**
 * @generated from message walletpasses.v1.CreateWalletPassTemplateResponse
 */
export type CreateWalletPassTemplateResponse = Message<"walletpasses.v1.CreateWalletPassTemplateResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplate | undefined;
};

/**
 * @generated from message walletpasses.v1.CreateWalletPassTemplateResponse
 */
export type CreateWalletPassTemplateResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplateJson;
};

/**
 * Describes the message walletpasses.v1.CreateWalletPassTemplateResponse.
 * Use `create(CreateWalletPassTemplateResponseSchema)` to create a new message.
 */
export const CreateWalletPassTemplateResponseSchema: GenMessage<CreateWalletPassTemplateResponse, { jsonType: CreateWalletPassTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 13);

/**
 * @generated from message walletpasses.v1.CreateWalletPassTemplateVersionRequest
 */
export type CreateWalletPassTemplateVersionRequest = Message<"walletpasses.v1.CreateWalletPassTemplateVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion: string;
};

/**
 * @generated from message walletpasses.v1.CreateWalletPassTemplateVersionRequest
 */
export type CreateWalletPassTemplateVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion?: string;
};

/**
 * Describes the message walletpasses.v1.CreateWalletPassTemplateVersionRequest.
 * Use `create(CreateWalletPassTemplateVersionRequestSchema)` to create a new message.
 */
export const CreateWalletPassTemplateVersionRequestSchema: GenMessage<CreateWalletPassTemplateVersionRequest, { jsonType: CreateWalletPassTemplateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 14);

/**
 * @generated from message walletpasses.v1.CreateWalletPassTemplateVersionResponse
 */
export type CreateWalletPassTemplateVersionResponse = Message<"walletpasses.v1.CreateWalletPassTemplateVersionResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplate | undefined;
};

/**
 * @generated from message walletpasses.v1.CreateWalletPassTemplateVersionResponse
 */
export type CreateWalletPassTemplateVersionResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplateJson;
};

/**
 * Describes the message walletpasses.v1.CreateWalletPassTemplateVersionResponse.
 * Use `create(CreateWalletPassTemplateVersionResponseSchema)` to create a new message.
 */
export const CreateWalletPassTemplateVersionResponseSchema: GenMessage<CreateWalletPassTemplateVersionResponse, { jsonType: CreateWalletPassTemplateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 15);

/**
 * @generated from message walletpasses.v1.PublishWalletPassTemplateVersionRequest
 */
export type PublishWalletPassTemplateVersionRequest = Message<"walletpasses.v1.PublishWalletPassTemplateVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility: string;
};

/**
 * @generated from message walletpasses.v1.PublishWalletPassTemplateVersionRequest
 */
export type PublishWalletPassTemplateVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility?: string;
};

/**
 * Describes the message walletpasses.v1.PublishWalletPassTemplateVersionRequest.
 * Use `create(PublishWalletPassTemplateVersionRequestSchema)` to create a new message.
 */
export const PublishWalletPassTemplateVersionRequestSchema: GenMessage<PublishWalletPassTemplateVersionRequest, { jsonType: PublishWalletPassTemplateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 16);

/**
 * @generated from message walletpasses.v1.PublishWalletPassTemplateVersionResponse
 */
export type PublishWalletPassTemplateVersionResponse = Message<"walletpasses.v1.PublishWalletPassTemplateVersionResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplate | undefined;
};

/**
 * @generated from message walletpasses.v1.PublishWalletPassTemplateVersionResponse
 */
export type PublishWalletPassTemplateVersionResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplateJson;
};

/**
 * Describes the message walletpasses.v1.PublishWalletPassTemplateVersionResponse.
 * Use `create(PublishWalletPassTemplateVersionResponseSchema)` to create a new message.
 */
export const PublishWalletPassTemplateVersionResponseSchema: GenMessage<PublishWalletPassTemplateVersionResponse, { jsonType: PublishWalletPassTemplateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 17);

/**
 * @generated from message walletpasses.v1.GetWalletPassTemplateRequest
 */
export type GetWalletPassTemplateRequest = Message<"walletpasses.v1.GetWalletPassTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message walletpasses.v1.GetWalletPassTemplateRequest
 */
export type GetWalletPassTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message walletpasses.v1.GetWalletPassTemplateRequest.
 * Use `create(GetWalletPassTemplateRequestSchema)` to create a new message.
 */
export const GetWalletPassTemplateRequestSchema: GenMessage<GetWalletPassTemplateRequest, { jsonType: GetWalletPassTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 18);

/**
 * @generated from message walletpasses.v1.GetWalletPassTemplateResponse
 */
export type GetWalletPassTemplateResponse = Message<"walletpasses.v1.GetWalletPassTemplateResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplate | undefined;
};

/**
 * @generated from message walletpasses.v1.GetWalletPassTemplateResponse
 */
export type GetWalletPassTemplateResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplateJson;
};

/**
 * Describes the message walletpasses.v1.GetWalletPassTemplateResponse.
 * Use `create(GetWalletPassTemplateResponseSchema)` to create a new message.
 */
export const GetWalletPassTemplateResponseSchema: GenMessage<GetWalletPassTemplateResponse, { jsonType: GetWalletPassTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 19);

/**
 * @generated from message walletpasses.v1.ListWalletPassTemplatesRequest
 */
export type ListWalletPassTemplatesRequest = Message<"walletpasses.v1.ListWalletPassTemplatesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string folder_id = 3;
	 */
	folderId: string;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags: string[];

	/**
	 * @generated from field: repeated string visibilities = 8;
	 */
	visibilities: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message walletpasses.v1.ListWalletPassTemplatesRequest
 */
export type ListWalletPassTemplatesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string folder_id = 3;
	 */
	folderId?: string;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags?: string[];

	/**
	 * @generated from field: repeated string visibilities = 8;
	 */
	visibilities?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message walletpasses.v1.ListWalletPassTemplatesRequest.
 * Use `create(ListWalletPassTemplatesRequestSchema)` to create a new message.
 */
export const ListWalletPassTemplatesRequestSchema: GenMessage<ListWalletPassTemplatesRequest, { jsonType: ListWalletPassTemplatesRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 20);

/**
 * @generated from message walletpasses.v1.ListWalletPassTemplatesResponse
 */
export type ListWalletPassTemplatesResponse = Message<"walletpasses.v1.ListWalletPassTemplatesResponse"> & {
	/**
	 * @generated from field: repeated walletpasses.v1.WalletPassTemplate wallet_pass_templates = 1;
	 */
	walletPassTemplates: WalletPassTemplate[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message walletpasses.v1.ListWalletPassTemplatesResponse
 */
export type ListWalletPassTemplatesResponseJson = {
	/**
	 * @generated from field: repeated walletpasses.v1.WalletPassTemplate wallet_pass_templates = 1;
	 */
	walletPassTemplates?: WalletPassTemplateJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message walletpasses.v1.ListWalletPassTemplatesResponse.
 * Use `create(ListWalletPassTemplatesResponseSchema)` to create a new message.
 */
export const ListWalletPassTemplatesResponseSchema: GenMessage<ListWalletPassTemplatesResponse, { jsonType: ListWalletPassTemplatesResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 21);

/**
 * @generated from message walletpasses.v1.UpdateWalletPassTemplateRequest
 */
export type UpdateWalletPassTemplateRequest = Message<"walletpasses.v1.UpdateWalletPassTemplateRequest"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplate | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message walletpasses.v1.UpdateWalletPassTemplateRequest
 */
export type UpdateWalletPassTemplateRequestJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplateJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message walletpasses.v1.UpdateWalletPassTemplateRequest.
 * Use `create(UpdateWalletPassTemplateRequestSchema)` to create a new message.
 */
export const UpdateWalletPassTemplateRequestSchema: GenMessage<UpdateWalletPassTemplateRequest, { jsonType: UpdateWalletPassTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 22);

/**
 * @generated from message walletpasses.v1.UpdateWalletPassTemplateResponse
 */
export type UpdateWalletPassTemplateResponse = Message<"walletpasses.v1.UpdateWalletPassTemplateResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplate | undefined;
};

/**
 * @generated from message walletpasses.v1.UpdateWalletPassTemplateResponse
 */
export type UpdateWalletPassTemplateResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPassTemplate wallet_pass_template = 1;
	 */
	walletPassTemplate?: WalletPassTemplateJson;
};

/**
 * Describes the message walletpasses.v1.UpdateWalletPassTemplateResponse.
 * Use `create(UpdateWalletPassTemplateResponseSchema)` to create a new message.
 */
export const UpdateWalletPassTemplateResponseSchema: GenMessage<UpdateWalletPassTemplateResponse, { jsonType: UpdateWalletPassTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 23);

/**
 * @generated from message walletpasses.v1.DeleteWalletPassTemplateRequest
 */
export type DeleteWalletPassTemplateRequest = Message<"walletpasses.v1.DeleteWalletPassTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message walletpasses.v1.DeleteWalletPassTemplateRequest
 */
export type DeleteWalletPassTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message walletpasses.v1.DeleteWalletPassTemplateRequest.
 * Use `create(DeleteWalletPassTemplateRequestSchema)` to create a new message.
 */
export const DeleteWalletPassTemplateRequestSchema: GenMessage<DeleteWalletPassTemplateRequest, { jsonType: DeleteWalletPassTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 24);

/**
 * @generated from message walletpasses.v1.DeleteWalletPassTemplateResponse
 */
export type DeleteWalletPassTemplateResponse = Message<"walletpasses.v1.DeleteWalletPassTemplateResponse"> & {};

/**
 * @generated from message walletpasses.v1.DeleteWalletPassTemplateResponse
 */
export type DeleteWalletPassTemplateResponseJson = {};

/**
 * Describes the message walletpasses.v1.DeleteWalletPassTemplateResponse.
 * Use `create(DeleteWalletPassTemplateResponseSchema)` to create a new message.
 */
export const DeleteWalletPassTemplateResponseSchema: GenMessage<DeleteWalletPassTemplateResponse, { jsonType: DeleteWalletPassTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 25);

/**
 * @generated from message walletpasses.v1.WalletPass
 */
export type WalletPass = Message<"walletpasses.v1.WalletPass"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string provider_id = 2;
	 */
	providerId: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string timezone = 7;
	 */
	timezone: string;

	/**
	 * @generated from field: common.v1.Creator creator = 8;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string state = 9;
	 */
	state: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags: string[];

	/**
	 * @generated from field: optional string brand_kit_id = 24;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: string batch_id = 12;
	 */
	batchId: string;

	/**
	 * @generated from field: string provider_batch_id = 13;
	 */
	providerBatchId: string;

	/**
	 * @generated from field: string template_id = 14;
	 */
	templateId: string;

	/**
	 * @generated from field: string provider_template_id = 15;
	 */
	providerTemplateId: string;

	/**
	 * @generated from field: string short_url = 18;
	 */
	shortUrl: string;

	/**
	 * @generated from field: string link_hash = 19;
	 */
	linkHash: string;

	/**
	 * @generated from field: string link_suffix = 20;
	 */
	linkSuffix: string;

	/**
	 * @generated from field: optional string domain_id = 22;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: string download_link = 23;
	 */
	downloadLink: string;

	/**
	 * @generated from field: repeated codes.v3.Destination destinations = 21;
	 */
	destinations: Destination[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 16;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 17;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message walletpasses.v1.WalletPass
 */
export type WalletPassJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string provider_id = 2;
	 */
	providerId?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string timezone = 7;
	 */
	timezone?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 8;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string state = 9;
	 */
	state?: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags?: string[];

	/**
	 * @generated from field: optional string brand_kit_id = 24;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: string batch_id = 12;
	 */
	batchId?: string;

	/**
	 * @generated from field: string provider_batch_id = 13;
	 */
	providerBatchId?: string;

	/**
	 * @generated from field: string template_id = 14;
	 */
	templateId?: string;

	/**
	 * @generated from field: string provider_template_id = 15;
	 */
	providerTemplateId?: string;

	/**
	 * @generated from field: string short_url = 18;
	 */
	shortUrl?: string;

	/**
	 * @generated from field: string link_hash = 19;
	 */
	linkHash?: string;

	/**
	 * @generated from field: string link_suffix = 20;
	 */
	linkSuffix?: string;

	/**
	 * @generated from field: optional string domain_id = 22;
	 */
	domainId?: string;

	/**
	 * @generated from field: string download_link = 23;
	 */
	downloadLink?: string;

	/**
	 * @generated from field: repeated codes.v3.Destination destinations = 21;
	 */
	destinations?: DestinationJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 16;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 17;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message walletpasses.v1.WalletPass.
 * Use `create(WalletPassSchema)` to create a new message.
 */
export const WalletPassSchema: GenMessage<WalletPass, { jsonType: WalletPassJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 26);

/**
 * @generated from message walletpasses.v1.CreateWalletPassRequest
 */
export type CreateWalletPassRequest = Message<"walletpasses.v1.CreateWalletPassRequest"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPass | undefined;
};

/**
 * @generated from message walletpasses.v1.CreateWalletPassRequest
 */
export type CreateWalletPassRequestJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPassJson;
};

/**
 * Describes the message walletpasses.v1.CreateWalletPassRequest.
 * Use `create(CreateWalletPassRequestSchema)` to create a new message.
 */
export const CreateWalletPassRequestSchema: GenMessage<CreateWalletPassRequest, { jsonType: CreateWalletPassRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 27);

/**
 * @generated from message walletpasses.v1.CreateWalletPassResponse
 */
export type CreateWalletPassResponse = Message<"walletpasses.v1.CreateWalletPassResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPass | undefined;
};

/**
 * @generated from message walletpasses.v1.CreateWalletPassResponse
 */
export type CreateWalletPassResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPassJson;
};

/**
 * Describes the message walletpasses.v1.CreateWalletPassResponse.
 * Use `create(CreateWalletPassResponseSchema)` to create a new message.
 */
export const CreateWalletPassResponseSchema: GenMessage<CreateWalletPassResponse, { jsonType: CreateWalletPassResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 28);

/**
 * @generated from message walletpasses.v1.GetWalletPassRequest
 */
export type GetWalletPassRequest = Message<"walletpasses.v1.GetWalletPassRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message walletpasses.v1.GetWalletPassRequest
 */
export type GetWalletPassRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message walletpasses.v1.GetWalletPassRequest.
 * Use `create(GetWalletPassRequestSchema)` to create a new message.
 */
export const GetWalletPassRequestSchema: GenMessage<GetWalletPassRequest, { jsonType: GetWalletPassRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 29);

/**
 * @generated from message walletpasses.v1.GetWalletPassResponse
 */
export type GetWalletPassResponse = Message<"walletpasses.v1.GetWalletPassResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPass | undefined;
};

/**
 * @generated from message walletpasses.v1.GetWalletPassResponse
 */
export type GetWalletPassResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPassJson;
};

/**
 * Describes the message walletpasses.v1.GetWalletPassResponse.
 * Use `create(GetWalletPassResponseSchema)` to create a new message.
 */
export const GetWalletPassResponseSchema: GenMessage<GetWalletPassResponse, { jsonType: GetWalletPassResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 30);

/**
 * @generated from message walletpasses.v1.ListWalletPassesRequest
 */
export type ListWalletPassesRequest = Message<"walletpasses.v1.ListWalletPassesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string folder_id = 3;
	 */
	folderId: string;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags: string[];

	/**
	 * @generated from field: string batch_id = 7;
	 */
	batchId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 8;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message walletpasses.v1.ListWalletPassesRequest
 */
export type ListWalletPassesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string folder_id = 3;
	 */
	folderId?: string;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags?: string[];

	/**
	 * @generated from field: string batch_id = 7;
	 */
	batchId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 8;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message walletpasses.v1.ListWalletPassesRequest.
 * Use `create(ListWalletPassesRequestSchema)` to create a new message.
 */
export const ListWalletPassesRequestSchema: GenMessage<ListWalletPassesRequest, { jsonType: ListWalletPassesRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 31);

/**
 * @generated from message walletpasses.v1.ListWalletPassesResponse
 */
export type ListWalletPassesResponse = Message<"walletpasses.v1.ListWalletPassesResponse"> & {
	/**
	 * @generated from field: repeated walletpasses.v1.WalletPass wallet_passes = 1;
	 */
	walletPasses: WalletPass[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message walletpasses.v1.ListWalletPassesResponse
 */
export type ListWalletPassesResponseJson = {
	/**
	 * @generated from field: repeated walletpasses.v1.WalletPass wallet_passes = 1;
	 */
	walletPasses?: WalletPassJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message walletpasses.v1.ListWalletPassesResponse.
 * Use `create(ListWalletPassesResponseSchema)` to create a new message.
 */
export const ListWalletPassesResponseSchema: GenMessage<ListWalletPassesResponse, { jsonType: ListWalletPassesResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 32);

/**
 * @generated from message walletpasses.v1.UpdateWalletPassRequest
 */
export type UpdateWalletPassRequest = Message<"walletpasses.v1.UpdateWalletPassRequest"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPass | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message walletpasses.v1.UpdateWalletPassRequest
 */
export type UpdateWalletPassRequestJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPassJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message walletpasses.v1.UpdateWalletPassRequest.
 * Use `create(UpdateWalletPassRequestSchema)` to create a new message.
 */
export const UpdateWalletPassRequestSchema: GenMessage<UpdateWalletPassRequest, { jsonType: UpdateWalletPassRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 33);

/**
 * @generated from message walletpasses.v1.UpdateWalletPassResponse
 */
export type UpdateWalletPassResponse = Message<"walletpasses.v1.UpdateWalletPassResponse"> & {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPass | undefined;
};

/**
 * @generated from message walletpasses.v1.UpdateWalletPassResponse
 */
export type UpdateWalletPassResponseJson = {
	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 1;
	 */
	walletPass?: WalletPassJson;
};

/**
 * Describes the message walletpasses.v1.UpdateWalletPassResponse.
 * Use `create(UpdateWalletPassResponseSchema)` to create a new message.
 */
export const UpdateWalletPassResponseSchema: GenMessage<UpdateWalletPassResponse, { jsonType: UpdateWalletPassResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 34);

/**
 * @generated from message walletpasses.v1.DeleteWalletPassRequest
 */
export type DeleteWalletPassRequest = Message<"walletpasses.v1.DeleteWalletPassRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message walletpasses.v1.DeleteWalletPassRequest
 */
export type DeleteWalletPassRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message walletpasses.v1.DeleteWalletPassRequest.
 * Use `create(DeleteWalletPassRequestSchema)` to create a new message.
 */
export const DeleteWalletPassRequestSchema: GenMessage<DeleteWalletPassRequest, { jsonType: DeleteWalletPassRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 35);

/**
 * @generated from message walletpasses.v1.DeleteWalletPassResponse
 */
export type DeleteWalletPassResponse = Message<"walletpasses.v1.DeleteWalletPassResponse"> & {};

/**
 * @generated from message walletpasses.v1.DeleteWalletPassResponse
 */
export type DeleteWalletPassResponseJson = {};

/**
 * Describes the message walletpasses.v1.DeleteWalletPassResponse.
 * Use `create(DeleteWalletPassResponseSchema)` to create a new message.
 */
export const DeleteWalletPassResponseSchema: GenMessage<DeleteWalletPassResponse, { jsonType: DeleteWalletPassResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 36);

/**
 * @generated from message walletpasses.v1.IssueWelcomeEmailRequest
 */
export type IssueWelcomeEmailRequest = Message<"walletpasses.v1.IssueWelcomeEmailRequest"> & {
	/**
	 * @generated from field: string pass_id = 1;
	 */
	passId: string;

	/**
	 * @generated from field: string email = 4;
	 */
	email: string;
};

/**
 * @generated from message walletpasses.v1.IssueWelcomeEmailRequest
 */
export type IssueWelcomeEmailRequestJson = {
	/**
	 * @generated from field: string pass_id = 1;
	 */
	passId?: string;

	/**
	 * @generated from field: string email = 4;
	 */
	email?: string;
};

/**
 * Describes the message walletpasses.v1.IssueWelcomeEmailRequest.
 * Use `create(IssueWelcomeEmailRequestSchema)` to create a new message.
 */
export const IssueWelcomeEmailRequestSchema: GenMessage<IssueWelcomeEmailRequest, { jsonType: IssueWelcomeEmailRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 37);

/**
 * @generated from message walletpasses.v1.IssueWelcomeEmailResponse
 */
export type IssueWelcomeEmailResponse = Message<"walletpasses.v1.IssueWelcomeEmailResponse"> & {};

/**
 * @generated from message walletpasses.v1.IssueWelcomeEmailResponse
 */
export type IssueWelcomeEmailResponseJson = {};

/**
 * Describes the message walletpasses.v1.IssueWelcomeEmailResponse.
 * Use `create(IssueWelcomeEmailResponseSchema)` to create a new message.
 */
export const IssueWelcomeEmailResponseSchema: GenMessage<IssueWelcomeEmailResponse, { jsonType: IssueWelcomeEmailResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 38);

/**
 * @generated from message walletpasses.v1.IssueDownloadLinkRequest
 */
export type IssueDownloadLinkRequest = Message<"walletpasses.v1.IssueDownloadLinkRequest"> & {
	/**
	 * @generated from field: string pass_id = 1;
	 */
	passId: string;
};

/**
 * @generated from message walletpasses.v1.IssueDownloadLinkRequest
 */
export type IssueDownloadLinkRequestJson = {
	/**
	 * @generated from field: string pass_id = 1;
	 */
	passId?: string;
};

/**
 * Describes the message walletpasses.v1.IssueDownloadLinkRequest.
 * Use `create(IssueDownloadLinkRequestSchema)` to create a new message.
 */
export const IssueDownloadLinkRequestSchema: GenMessage<IssueDownloadLinkRequest, { jsonType: IssueDownloadLinkRequestJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 39);

/**
 * @generated from message walletpasses.v1.IssueDownloadLinkResponse
 */
export type IssueDownloadLinkResponse = Message<"walletpasses.v1.IssueDownloadLinkResponse"> & {
	/**
	 * @generated from field: string download_link = 1;
	 */
	downloadLink: string;
};

/**
 * @generated from message walletpasses.v1.IssueDownloadLinkResponse
 */
export type IssueDownloadLinkResponseJson = {
	/**
	 * @generated from field: string download_link = 1;
	 */
	downloadLink?: string;
};

/**
 * Describes the message walletpasses.v1.IssueDownloadLinkResponse.
 * Use `create(IssueDownloadLinkResponseSchema)` to create a new message.
 */
export const IssueDownloadLinkResponseSchema: GenMessage<IssueDownloadLinkResponse, { jsonType: IssueDownloadLinkResponseJson }> = /*@__PURE__*/ messageDesc(file_walletpasses_v1_walletpasses, 40);

/**
 * @generated from service walletpasses.v1.WalletPassService
 */
export const WalletPassService: GenService<{
	/**
	 * Batch
	 *
	 * @generated from rpc walletpasses.v1.WalletPassService.CreateWalletPassBatch
	 */
	createWalletPassBatch: {
		methodKind: "unary";
		input: typeof CreateWalletPassBatchRequestSchema;
		output: typeof CreateWalletPassBatchResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.GetWalletPassBatch
	 */
	getWalletPassBatch: {
		methodKind: "unary";
		input: typeof GetWalletPassBatchRequestSchema;
		output: typeof GetWalletPassBatchResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.ListWalletPassBatches
	 */
	listWalletPassBatches: {
		methodKind: "unary";
		input: typeof ListWalletPassBatchesRequestSchema;
		output: typeof ListWalletPassBatchesResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.UpdateWalletPassBatch
	 */
	updateWalletPassBatch: {
		methodKind: "unary";
		input: typeof UpdateWalletPassBatchRequestSchema;
		output: typeof UpdateWalletPassBatchResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.DeleteWalletPassBatch
	 */
	deleteWalletPassBatch: {
		methodKind: "unary";
		input: typeof DeleteWalletPassBatchRequestSchema;
		output: typeof DeleteWalletPassBatchResponseSchema;
	};
	/**
	 * Template
	 *
	 * @generated from rpc walletpasses.v1.WalletPassService.CreateWalletPassTemplate
	 */
	createWalletPassTemplate: {
		methodKind: "unary";
		input: typeof CreateWalletPassTemplateRequestSchema;
		output: typeof CreateWalletPassTemplateResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.CreateWalletPassTemplateVersion
	 */
	createWalletPassTemplateVersion: {
		methodKind: "unary";
		input: typeof CreateWalletPassTemplateVersionRequestSchema;
		output: typeof CreateWalletPassTemplateVersionResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.PublishWalletPassTemplateVersion
	 */
	publishWalletPassTemplateVersion: {
		methodKind: "unary";
		input: typeof PublishWalletPassTemplateVersionRequestSchema;
		output: typeof PublishWalletPassTemplateVersionResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.GetWalletPassTemplate
	 */
	getWalletPassTemplate: {
		methodKind: "unary";
		input: typeof GetWalletPassTemplateRequestSchema;
		output: typeof GetWalletPassTemplateResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.ListWalletPassTemplates
	 */
	listWalletPassTemplates: {
		methodKind: "unary";
		input: typeof ListWalletPassTemplatesRequestSchema;
		output: typeof ListWalletPassTemplatesResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.UpdateWalletPassTemplate
	 */
	updateWalletPassTemplate: {
		methodKind: "unary";
		input: typeof UpdateWalletPassTemplateRequestSchema;
		output: typeof UpdateWalletPassTemplateResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.DeleteWalletPassTemplate
	 */
	deleteWalletPassTemplate: {
		methodKind: "unary";
		input: typeof DeleteWalletPassTemplateRequestSchema;
		output: typeof DeleteWalletPassTemplateResponseSchema;
	};
	/**
	 * Pass
	 *
	 * @generated from rpc walletpasses.v1.WalletPassService.CreateWalletPass
	 */
	createWalletPass: {
		methodKind: "unary";
		input: typeof CreateWalletPassRequestSchema;
		output: typeof CreateWalletPassResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.GetWalletPass
	 */
	getWalletPass: {
		methodKind: "unary";
		input: typeof GetWalletPassRequestSchema;
		output: typeof GetWalletPassResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.ListWalletPasses
	 */
	listWalletPasses: {
		methodKind: "unary";
		input: typeof ListWalletPassesRequestSchema;
		output: typeof ListWalletPassesResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.UpdateWalletPass
	 */
	updateWalletPass: {
		methodKind: "unary";
		input: typeof UpdateWalletPassRequestSchema;
		output: typeof UpdateWalletPassResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.DeleteWalletPass
	 */
	deleteWalletPass: {
		methodKind: "unary";
		input: typeof DeleteWalletPassRequestSchema;
		output: typeof DeleteWalletPassResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.IssueWelcomeEmail
	 */
	issueWelcomeEmail: {
		methodKind: "unary";
		input: typeof IssueWelcomeEmailRequestSchema;
		output: typeof IssueWelcomeEmailResponseSchema;
	};
	/**
	 * @generated from rpc walletpasses.v1.WalletPassService.IssueDownloadLink
	 */
	issueDownloadLink: {
		methodKind: "unary";
		input: typeof IssueDownloadLinkRequestSchema;
		output: typeof IssueDownloadLinkResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_walletpasses_v1_walletpasses, 0);
